import { jsx as _jsx } from "react/jsx-runtime";
import { PaginationRow } from "@faire/retailer-visitor-shared/features/Marketplace/style";
import { useCategoryPagePaginationData } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPagePaginationData";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Pagination } from "@faire/web--source/slate/Pagination";
import React from "react";
export var CategoryPagePagination = function(param) {
    var onChangePage = param.onChangePage;
    var paginationData = useCategoryPagePaginationData();
    var handlePaginationLink = function(pageNumber) {
        var currentFilterPath = getCurrentPath().delete("page");
        if (pageNumber === 1) {
            return currentFilterPath.toString();
        }
        return currentFilterPath.append({
            page: pageNumber.toString()
        }).toString();
    };
    var _paginationData_page_count;
    var shouldShowPagination = paginationData && ((_paginationData_page_count = paginationData.page_count) !== null && _paginationData_page_count !== void 0 ? _paginationData_page_count : 0) > 1;
    if (!shouldShowPagination) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PaginationRow, {
        children: /*#__PURE__*/ _jsx(Pagination, {
            paginationData: paginationData,
            pageToLink: handlePaginationLink,
            onChangePage: onChangePage
        })
    });
};
